import { render, staticRenderFns } from "./PurchaseDetails_Total.vue?vue&type=template&id=2586447f&"
import script from "./PurchaseDetails_Total.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetails_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports